import axios from 'axios'
import httpClient from '@/api/httpClient'

class GoogleGeoCoding {
  // geologic の API が proxy しているので、httpClient を使わないと通信できない。、
  static async placeAutoComplete(input, language = 'ja', options = {}) {
    const endpoint = `/googleapi/place/autocomplete`
    const params = {
      input,
      language,
      ...options,
    }
    const res = await httpClient.get(endpoint, {
      params,
    })
    return res.data
  }

  // 直接 Google API を叩く
  static async geoCoding(address) {
    const googleGeoCodingKey = process.env.VUE_APP_API_GOOGLEMAP_API_KEY
    const endpoint = 'https://maps.googleapis.com/maps/api/geocode/json'
    const res = await axios.get(endpoint, {
      params: {
        key: googleGeoCodingKey,
        address,
      },
    })
    return res.data
  }

  // 直接 Google API を叩く
  static async reverseGeoCoding({ lng, lat }) {
    const googleGeoCodingKey = process.env.VUE_APP_API_GOOGLEMAP_API_KEY
    const endpoint = 'https://maps.googleapis.com/maps/api/geocode/json'
    const res = await axios.get(endpoint, {
      params: {
        key: googleGeoCodingKey,
        latlng: `${lat},${lng}`,
      },
    })
    return res.data
  }
}

export default GoogleGeoCoding
